import { createAction } from "@reduxjs/toolkit";
export const logout = createAction("logout");
export const removeBrandData = createAction("removeBrandData");
